import { useQuery } from "react-query";
import yearPlanAPI from "../../../api/yearPlanAPI";

export const useAllYearPlans = () =>
  useQuery(["yearPlans", "all"], yearPlanAPI.fetchYearPlans);
